import { useEffect, useState, useCallback } from "preact/hooks";
import { off, on } from "futurise";
import { noop } from "../tools/noop";
import { EMPTY_ARRAY } from "unchangeable";

type StyleSheetLoaderProps = {
  value?: readonly HTMLLinkElement[];
  children: preact.ComponentChildren;
};

/**
 * Waits for all stylesheets to be loaded before rendering children.
 */
export function StyleSheetLoader({ value, children }: StyleSheetLoaderProps) {
  const [remaining, setRemaining] = useState(value?.length ?? 0);

  const done = useCallback(() => {
    setRemaining((remaining) => remaining - 1);
  }, EMPTY_ARRAY);

  useEffect(() => {
    if (value == null) {
      return;
    }
    return off(
      ...value.map((link) => {
        if (link.sheet != null) {
          done();
          return noop;
        }
        return on(link, "load", done);
      }),
    );
  }, EMPTY_ARRAY);

  if (remaining > 0) {
    return null;
  }

  return children;
}
